import { render, staticRenderFns } from "./FilterCriteriaDate.vue?vue&type=template&id=2b7767b4&scoped=true&"
import script from "./FilterCriteriaDate.vue?vue&type=script&lang=js&"
export * from "./FilterCriteriaDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7767b4",
  null
  
)

/* custom blocks */
import block0 from "./FilterCriteriaDate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b7767b4')) {
      api.createRecord('2b7767b4', component.options)
    } else {
      api.reload('2b7767b4', component.options)
    }
    module.hot.accept("./FilterCriteriaDate.vue?vue&type=template&id=2b7767b4&scoped=true&", function () {
      api.rerender('2b7767b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comparison/filter-criteria/FilterCriteriaDate.vue"
export default component.exports